import {
  jb_breadcrumbs_item_css_default
} from "./chunk.ZS5HOLVI.js";
import {
  Linkable
} from "./chunk.MFPI4EPN.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-breadcrumbs-item/jb-breadcrumbs-item.ts
var JbBreadcrumbsItem = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this.inactive = false;
  }
  render() {
    return ke`
      <span role="listitem">
        <jb-anchor
          flyPadding="0"
          ?inactive=${this.inactive || !this.link?.href}
          .link=${this.link}
          >${this.text}
        </jb-anchor>
      </span>
    `;
  }
};
JbBreadcrumbsItem.styles = [reset_css_default, jb_breadcrumbs_item_css_default];
__decorateClass([
  n({ type: Boolean })
], JbBreadcrumbsItem.prototype, "inactive", 2);
__decorateClass([
  n()
], JbBreadcrumbsItem.prototype, "text", 2);
JbBreadcrumbsItem = __decorateClass([
  customElement("jb-breadcrumbs-item")
], JbBreadcrumbsItem);

export {
  JbBreadcrumbsItem
};
